import {Component, inject} from '@angular/core';
import {PermissionsService} from '@q9elements/ui-kit/common';
import {RefModelSidebarService} from '@q9elements/ui-kit/refmodels';
import {InternalNodeSidebarBaseTab} from '../../models/base-tab.component';
import {InternalNodeSidebarSubTabs} from '../../models/portals';

@Component({
  selector: 'q9rme-details-tab',
  templateUrl: './node-details-tab.component.html',
  styleUrls: ['./node-details-tab.component.scss']
})
export class DetailsTabComponent extends InternalNodeSidebarBaseTab {
  private refModelSidebarService = inject(RefModelSidebarService);
  private permissionsService = inject(PermissionsService);

  public readonly SUB_TABS = InternalNodeSidebarSubTabs;

  public stakeholdersCount = this.refModelSidebarService.stakeholdersCount;

  private readonly refModelNode = this.refModelSidebarService.refModelNode;
  private readonly isRefModel = this.refModelSidebarService.isRefModel;

  override selectedTab = InternalNodeSidebarSubTabs.SystemInfoTab;

  public isStakeholdersShown(): boolean {
    if (!this.permissionsService.isProPlus()) {
      return false;
    }

    const node = this.refModelNode()!;
    const isRefModel = !node.sf && !this.isRefModel();

    return isRefModel;
  }
}
